import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import { getNotificationHistory, getUsers } from '../data/mockData';
import NotificationHistory from '../components/notifications/NotificationHistory';
import SendNotificationModal from '../components/receptionist/SendNotificationModal';
import useDidFetch from '../custom_hooks/useDidfetch';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';

const ReceptionistNotificationsPage = () => {
    const [history, setHistory] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [members, setMembers] = useState([]);
    const [trainers, setTrainers] = useState([]);
    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllUser();
            getMembers();
            getAllNotifications();
        });
    }, []);
    const getTrainers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/trainer`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setTrainers(result?.users ?? []);
            }
        } catch (error) {
            console.error("trainer error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    
     const getAllUser = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getUser);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) { 
                const trainers = result?.users.filter(u => u.role?.name == 'trainer');
                console.log(trainers);
                setTrainers(trainers);
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getMembers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/member`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setMembers(result?.users ?? []);
            }
        } catch (error) {
            console.error("getMembers error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    const getAllNotifications = async () => {
        try {
            let response = await api.get(ENDPOINTS.getNotificationApi);
            let result = response?.data ?? [];
            if (response?.status == 200 || response?.status == 201) {
                setHistory(result);
            }

        } catch (error) {
            console.log("getNotifyHistory error", error);
        }
    }

    const handleSend = async (notificationData) => {
        console.log("notificationData", notificationData);
        let notifData = {
            "target": notificationData?.targetAudience,
            "user_id": notificationData?.specificUser,
            "title": notificationData?.title, 
            "message": notificationData?.message,
            "platform" : notificationData?.channels
        }

        try {
            setIsLoading(true);
            let response = await api.post(ENDPOINTS.notificationApi, notifData);
            let result = response.data;
            if (response?.status == 200 || response?.status == 201) {
                toast.success(`Notification has been Sent.`);
                setIsModalOpen(false);
                getAllNotifications();
            }
        } catch (error) {
            console.log("handleSend notification", error);
        } finally {
            setIsLoading(false)
        }
        return;

        const newNotification = {
            id: `NOTIF-${Date.now()}`,
            ...notificationData,
            timestamp: notificationData.scheduleTime || new Date(),
            status: notificationData.scheduleTime ? 'Scheduled' : 'Sent',
        };
        setHistory([newNotification, ...history]);
    };

    return (
        <>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="space-y-6"
            >
                <div className="flex justify-between items-center">
                    <h1 className="text-3xl font-bold font-display text-gray-800">Notifications</h1>
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="flex items-center gap-2 px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600 text-sm font-medium"
                    >
                        <Plus size={16} /> Send Notification
                    </button>
                </div>
                <NotificationHistory notifications={history} />
            </motion.div>
            <SendNotificationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSend={handleSend}
                users={[]}
                members={members}
                trainers={trainers}
                isLoading={isLoading}
            />
        </>
    );
};

export default ReceptionistNotificationsPage;
